import { render, staticRenderFns } from "./AnnotationMultiSelect.vue?vue&type=template&id=156c6d04&scoped=true"
import script from "./AnnotationMultiSelect.vue?vue&type=script&lang=js"
export * from "./AnnotationMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./AnnotationMultiSelect.vue?vue&type=style&index=0&id=156c6d04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156c6d04",
  null
  
)

export default component.exports